module.exports = __webpack_public_path__ + "static/img/hhd_vip_04.40677c2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/member/hhd_vip_04.jpg
// module id = YUVg
// module chunks = 1